const find_holdings = (filter, holdings) => {
  let result = holdings

  const name_filter = filter.search.toLowerCase()
  if (name_filter.length != 0) {
    result = result.filter(holding => holding.name.toLowerCase().includes(name_filter) || holding.symbol.toLowerCase() == name_filter)
  }

  const country_filter = (filter.countries || []).map(c => c.toLowerCase())
  if (country_filter.length != 0) {
    result = result.filter(holding => country_filter.some(country => holding.country.toLowerCase().includes(country)))
  }

  const sector_filter = filter.sectors || []
  if (sector_filter.length != 0) {
    result = result.filter(holding => sector_filter.some(sector => holding.sector == sector))
  }

  result = _.orderBy(result, 'owned', 'desc')
  return result
}
export default {
  find_holdings
}
